import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * Room+ variant region: a part of the product page that depends on the selected variant
 * (delivery amount, back-in-stock form, SKU). When the shopper picks another variant, Horizon
 * fetches the new section HTML; this element takes its own updated copy (same id) from it.
 */
class RpVariantRegion extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /** @param {any} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html || !this.id) return;

        const updated = html.getElementById ? html.getElementById(this.id) : html.querySelector(`#${CSS.escape(this.id)}`);
        if (updated) morph(this, updated, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[rp-variant-region]', error);
      });
  };
}

if (!customElements.get('rp-variant-region')) {
  customElements.define('rp-variant-region', RpVariantRegion);
}
